import React from 'react';
import { ClipboardCheckIcon, BoltIcon, PrinterIcon, AlertTriangleIcon, CalendarDaysIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const bonos = [{
  n: 1,
  icon: ClipboardCheckIcon,
  title: 'Checklist de Herramientas Básicas para el Hogar',
  text: 'Una lista simple para saber exactamente qué comprar desde el primer día sin gastar de más ni perderte en la ferretería.'
}, {
  n: 2,
  icon: BoltIcon,
  title: 'Guía Rápida de Tornillos, Tarugos y Brocas',
  text: 'Nunca más dudes qué materiales usar. Una guía visual para elegir los correctos según tu tipo de pared.'
}, {
  n: 3,
  icon: PrinterIcon,
  title: 'Plantilla Imprimible para Colgar Repisas Sin Errores',
  text: 'Planificá tu instalación antes de perforar. Anotá medidas, materiales y tipo de pared para no fallar.'
}, {
  n: 4,
  icon: AlertTriangleIcon,
  title: 'Lista de Errores Comunes que Debés Evitar',
  text: 'Conocé los fallos más frecuentes de los principiantes para que vos no los repitas desde el inicio.'
}, {
  n: 5,
  icon: CalendarDaysIcon,
  title: 'Mini Guía de Proyectos Fáciles de Fin de Semana',
  text: 'Ideas simples para mejorar tu hogar en pocas horas. Perfectas para empezar a practicar con resultados visibles.'
}];
export function Bonos() {
  return <section aria-labelledby="bonos-titulo" className="w-full bg-cream" data-id="element-15" data-mp="x7oqvne9pd0">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-16" data-mp="v4z4cq5ly8t">
        <Reveal data-id="element-17" data-mp="3s4bpj8sy4fcz">
          <SectionLabel data-id="element-18" data-mp="3s1pida9yw1va">Bonos incluidos</SectionLabel>
          <h2 id="bonos-titulo" className="mt-4 font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-19" data-mp="3n3wckickt9vj">
            5 bonos completamente gratis
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-graphite" data-id="element-20" data-mp="2bqljhwi9nh0p">
            Con tu compra recibís también estos 5 recursos adicionales sin costo
            extra.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="yqqo72f2j9dy">
          {bonos.map(({
          n,
          icon: Icon,
          title,
          text
        }, i) => <Reveal key={n} delay={i * 0.06} className="h-full" data-id="element-22" data-mp="12rsrbuc3w5l7" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border-2 border-dashed border-ink/25 bg-sand/60 p-6 transition-colors duration-200 hover:border-clay" data-id="element-23" data-mp="orrhvqhrzpu4">
                <div className="flex items-center gap-3" data-id="element-24" data-mp="f39klj8pg0v8">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ink text-cream" data-id="element-25" data-mp="f1q3jqf85lse">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-26" data-mp="jvudmijse9xp" />
                  </span>
                  <span className="rounded-full bg-clay/12 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-clay" data-id="element-27" data-mp="6460cbxsxff5">
                    Bono {n} · Gratis
                  </span>
                </div>
                <h3 className="mt-5 font-display text-lg font-bold leading-snug" data-id="element-28" data-mp="3sbvuxqwyv09l">
                  {title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-29" data-mp="3dmaxi0qv9yer">
                  {text}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}